<template>
    <div>
        <div class="container-md ">
            <div class=" container-bg p-5 ">
                <div class="row">
                    <div class="col-6">
                        <h3 class="text-uppercase">Mijn Items</h3>

                    </div>
                    <div class="col-6">
                        <i class="fa fa-plus float-right " data-toggle="modal" data-target="#newItem"
                           style="font-size: 24px;cursor: pointer"></i>
                    </div>
                    
                    <!-- 
                        https://xd.adobe.com/view/1fb01f03-934e-407d-72ce-1fd6b97f4211-6981/screen/9d529ef3-41a6-4d27-9d5b-85f2a162100e/Profile-My-items
                     -->
                    

                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="newItem" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "items",
    }
</script>

<style scoped>

</style>
